<div class="layout">
    <div class="start-image-section">
        <div class="image-container">
            <img src="HomeBannerSection_Start.png" fetchPriority="high" class="background-image">
        </div>
        <div class="text-container">
            <p class="intro-text-title">{{'home.intro-text-title' | translate}}</p>
            <p class="intro-text-subheading">{{'home.intro-text-subheading' | translate}}</p>
        </div>
        <div class="mascot-container">
            <img src="Happy_Cat.png">
        </div>
    </div>
    <div class="about-container">
        <img src="Logo_Small.png">
        <div class="about-info">
            <h1>
                <span>{{'home.about-info-we_are' | translate}}</span>
                {{'home.about-info-compann_name' | translate}}
            </h1>
            <p>{{'home.about-info-text' | translate}}</p>
        </div>
    </div>
    <div class="step-list-container">
        <div>
            <h1>{{'home.step-list.heading' | translate}}</h1>
        </div>
        <div class="step-list">
            <ul>
                <li>
                    <span class="step-text">{{'home.step-list.contact' | translate}}</span>
                    <span class="material-symbols-outlined step-icon">outgoing_mail</span>
                </li>
                <li>
                    <span class="step-text">{{'home.step-list.contract' | translate}}</span>
                    <span class="material-symbols-outlined step-icon">handshake</span>
                </li>
                <li>
                    <span class="step-text">{{'home.step-list.delivery' | translate}}</span>
                    <span class="material-symbols-outlined step-icon">local_shipping</span>
                </li>
            </ul>
        </div>
        <div class="delivery-note">
            <p><strong>{{'home.step-list.note' | translate}}</strong>{{'home.step-list.note.text' | translate}}</p>
            <p>{{'home.step-list.note.text2' | translate}}</p>
        </div>
    </div>
    <div class="mail-form-container" id="contact-section">
        <div class="mail-form-header">
            <h1>{{'home.mail-form.header' | translate}}</h1>
        </div>
        <div>
            <form [formGroup]="mailForm" #f="ngForm" (ngSubmit)="sendMail()" class="form-main">
                <mat-form-field class="full-width">
                    <mat-label>{{'home.mail-form.name' | translate}}</mat-label>
                    <input formControlName="from_customerName" matInput>
                    <mat-error ngIf="mailForm.get('from_customerName')?.hasError('required')">
                        {{'home.mail-form.fill' | translate}}
                    </mat-error>
                </mat-form-field>
                <div class="row">
                    <mat-form-field class="half-width">
                        <mat-label>{{'home.mail-form.mail' | translate}}</mat-label>
                        <input formControlName="from_email" matInput>
                        <mat-error ngIf="mailForm.get('from_email')?.hasError('email')">
                            {{'home.mail-form.fill-mail' | translate}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>{{'home.mail-form.phone' | translate}}</mat-label>
                        <input formControlName="from_phone" matInput (keydown)="restrictPhoneInput($event)">
                        <mat-error ngIf="mailForm.get('from_phone')?.hasError('required')">
                            {{'home.mail-form.fill' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="half-width">
                        <mat-label>{{'home.mail-form.event-type' | translate}}</mat-label>
                        <mat-select formControlName="event_type">
                            <mat-option value="Geburtstag">{{'home.mail-form.bday' | translate}}</mat-option>
                            <mat-option value="Firmenveranstaltung">{{'home.mail-form.company-event' |
                                translate}}</mat-option>
                            <mat-option value="Sonstige Events">{{'home.mail-form.miscellaneous' |
                                translate}}</mat-option>
                        </mat-select>
                        <mat-error ngIf="mailForm.get('event_type')?.hasError('required')">
                            {{'home.mail-form.fill' | translate}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>{{'home.mail-form.date' | translate}}</mat-label>
                        <input formControlName="date" matInput [matDatepicker]="picker" [min]="minDate">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error ngIf="mailForm.get('date')?.hasError('required')">
                            {{'home.mail-form.fill' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <mat-form-field class="full-width">
                    <mat-label>{{ 'home.mail-form.location' | translate }}</mat-label>
                    <input formControlName="event_location" matInput
                        [placeholder]="'home.mail-form.placeholder' | translate">
                    <mat-error ngIf="mailForm.get('event_location')?.hasError('required')">
                        {{ 'home.mail-form.fill' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>{{'home.mail-form.message' | translate}}</mat-label>
                    <textarea formControlName="message" matInput [attr.maxLength]="1000"
                        (input)="onMessageInput($event)" rows="15"></textarea>
                    <mat-error ngIf="mailForm.get('message')?.hasError('required') && mailForm.get('message')?.touched">
                        {{'home.mail-form.fill' | translate}}
                    </mat-error>
                </mat-form-field>
                <div class="checkbox-container">
                    <mat-checkbox formControlName="accept_terms">
                        <span>{{'home.mail-form.use-and-sale.part1' | translate}} </span><a
                            [routerLink]="'/conditions-of-use-and-sale'"
                            class="link">{{'home.mail-form.use-and-sale.part2' |
                            translate}}</a><span>{{'home.mail-form.use-and-sale.part3' | translate}}</span>
                    </mat-checkbox>
                    <mat-checkbox formControlName="accept_privacy">
                        <span>{{'home.mail-form.privacy.part1' | translate}}</span> <a [routerLink]="'/privacy-notice'"
                            class="link">{{'home.mail-form.privacy.part2' |
                            translate}}</a><span>{{'home.mail-form.privacy.part3' | translate}}</span>
                    </mat-checkbox>
                </div>
                <div class="button-row">
                    <button mat-stroked-button color="primary" (click)="sendSuccessMessage()" type="submit"
                        [disabled]="mailForm.invalid">
                        {{ 'home.mail-form.submit' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>